import { useEffect } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import type { HomepagePageUserData } from '#src/app/pages/homepage/pageContext';
import { useHomepagePageUserData } from '#src/app/pages/homepage/pageContext';
import { treatExperiment } from '#src/app/shared/api/experiments';

type UsePageBodyReturn = ModelHookResult<{ experiments: HomepagePageUserData['experiments'] }>;

export function usePageBody(): UsePageBodyReturn {
	const {
		data: { experiments },
	} = useHomepagePageUserData();
	const utilityContext = useUtilityContext();

	const { homepageHeroExperiment, starfishHomepageToSapDraftV1 } = experiments;

	// Nested experiments (non-standard — see renderHeroSection in PageBody): starfish is queried
	// with `treat: false` and only treated here, once we know the user fell out of the GrowthBook
	// hero experiment and the starfish experience is what actually renders. Skipped when starfish
	// itself resolved as fallback (disabled/not-found) or was QA-overridden — treating either
	// would record a bucketing that never really happened.
	useEffect(() => {
		if (!homepageHeroExperiment.fallback) return;
		if (starfishHomepageToSapDraftV1.treated || starfishHomepageToSapDraftV1.fallback) return;
		if (starfishHomepageToSapDraftV1.override) return;
		void treatExperiment(utilityContext, starfishHomepageToSapDraftV1.experimentName);
	}, [homepageHeroExperiment, starfishHomepageToSapDraftV1, utilityContext]);

	return { data: { experiments } };
}
